import React, { useEffect, useRef, useState } from "react";
import "../css/Creditcard.css";
import "../css/common.scss";
import DenialPage from "./DenialPage";
import Creditcardform from "./Creditcardform";
import loading from "../img/loader.gif";
import Resizer from 'react-image-file-resizer';
import front from "../img/card-front.png";
import back from "../img/card-back.png"
import config from "../config/config";
import OptionsSwitch from "./Optionswitch";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { decryptData } from "../utils/encrypDecrypt";

const overlayTextBoxStyle = {
    width: "223px", height: "74px"
}


const Creditcard = (props) => {
    // console.log(uuid);
    const fileInputRefs = {
        front: useRef(null),
        back: useRef(null)
    }
    const [files, setFiles] = useState({
        front: null,
        back: null
    });
    const [loaders, setLoaders] = useState({
        front: false,
        back: false
    });
    const [outputImages, setOutputImages] = useState({
        front: null,
        back: null
    });
    const [outputData, setOutputData] = useState({
        front: null,
        back: null
    });

    const [response, setResponse] = useState({});
    
    const [image, setImage] = useState([]);
    const [imagenum, setImagenum] = useState(0);
    const [show,setShow] = useState(0);
    const [mode, setMode] = useState("Scan"); 
    let childSubmitFunction;


    const proceed = ()=>{
        setShow(1);
    }

    const handleSubmitinfo = () => {
        childSubmitFunction();
    };

    // useEffect(() => {
    //     if(files.front && files.back){
    //         resizeAndCompressImages([files.front, files.back]);
    //     }
    // }, [files.front, files.back]);

    useEffect(() => {
        if(outputData.front && outputData.back){
            const a = outputData.front;
            const b = outputData.back;
            const merged = Object.fromEntries(
              Object.keys({...a, ...b}).map(k => [k, a[k] === "" ? b[k] : a[k]])
            );
            setResponse(merged);
        }
    }, [outputData.front, outputData.back]);

    if (props.uuid === '') {
        return <DenialPage/>;
    }

    const fileHandle = async(type) => {
        const files = fileInputRefs[type].current.files;
        if(files.length > 0) {
            const fileObj = files[0];
            setFiles(prev => ({ ...prev, [type]: fileObj }));
            fileInputRefs[type].current.value = '';
            const resizedFile = await resizeImage(fileObj);
            setLoaders(prev => ({ ...prev, [type]: true }));
            const result = await makeApiCall([resizedFile]);
            if(result.status) {
                setOutputImages(prev => ({ ...prev, [type]: result.images[0] }));
                setOutputData(prev => ({ ...prev, [type]: result.data }));
            }
            setLoaders(prev => ({ ...prev, [type]: false }));
        } else {
            setFiles(prev => ({ ...prev, [type]: null }));
        }
    };


    const resizeImage = (file) => {
        return new Promise((resolve, reject) => {
            Resizer.imageFileResizer(
                file, // input file
                1024, // max width
                1024, // max height
                'JPEG', // output format
                50, // quality (0-100)
                0, // rotation (0, 90, 180, 270)
                (uri) => {
                    // uri is the resized image
                    const resizedFile = uri instanceof Blob ? uri : dataURLtoFile(uri, file.name);
                    resolve(resizedFile);
                },
                'base64' // output type ('base64', 'blob', or 'file')
            );
        });
    };

    const dataURLtoFile = (dataUrl, filename) => {
        const arr = dataUrl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        // Ensure proper variable declarations, no reassignment of 'const'
        for (let i = 0; i < n; i++) {
            u8arr[i] = bstr.charCodeAt(i);
        }

        // Create the file object
        return new File([u8arr], filename, { type: mime });
    };

    const makeApiCall = async (newFiles) => {
        const formData = new FormData();
        newFiles.forEach((file) => {
            formData.append('images', file);
        });
        try {
            const response = await fetch(`${config.API_BASE_URL}/api/credit_card`, {
                method: 'POST', body: formData,
            });

            if (response.ok) {
                const result = await response.json();
                const decryptedData = JSON.parse(decryptData(result.data));
                const data = decryptedData.data.data.components.prompt_builder;
                const normalizedResponse = Object.fromEntries(
                    Object.entries(data).map(([key, value]) => [key.replace(/_/g, '-'), value])
                );
                return {status: true, images: decryptedData.images, data: normalizedResponse};
            } else {
                console.error("Error in API response:", response.statusText);
                return {status: false, images: [], data: {}};
            }
        } catch (error) {
            console.error("API Error:", error);
            return {status: false, images: [], data: {}};
        }
    };

    const handleimagepreview = (index) => {
        setImagenum(index);
    };
    const handleModeChange = (selectedMode) => {
        setMode(selectedMode);
        // console.log(mode);
    };
    


    return (
        <>
            <Navbar/>
            <div className="fullbody container container-50 main-content">
            <div className='row'>
            <div className='col-12'>
                <div className="innerbody card">
                   
                      <OptionsSwitch selectedOption={mode} onModeChange={handleModeChange} />
                      <div className="card-body">
                        <span className="copyright" style={{fontWeight:"600",textAlign:"left", fontSize: "15px"}}>
                            Selected Mode:
                        {mode == "Scan" ?" Auto":" Manual"}
                        </span>
                        <div className="demo-text mt-2">
                        {mode == "Scan" ?
                        <span className="copyright" style={{textAlign:"left"}} >Scan Front and Back of your card and we will auto pull your information. <a onClick={() => handleModeChange("Manual")}
                        style={{ cursor: "pointer", color: "#d7172f" }}>Switch to Manual</a></span>:<span className="copyright">Please provide your payment information.<a onClick={() => handleModeChange("Scan")}
                        style={{ cursor: "pointer", color: "#d7172f" }}> Switch to Auto</a></span>}
                        </div>
                    

            
                    {outputImages.front && outputImages.back && (
                        <>
                            {show == 1 && mode == "Scan"?
                                <div className="resultbox2" style={{ justifyContent: "center" }}>
                                    <div >
                                        <Creditcardform
                                            setSubmitFunction={(submitFunction) => (childSubmitFunction = submitFunction)}
                                            cardnumber={response['cardnumber']}
                                            cardholder={response['cardholder']}
                                            card_type={response['card_type']}
                                            ExpiryDate={response['ExpiryDate']}
                                            cvv_number={response['CVV']}
                                            zipcode=''
                                            uuid= {props.uuid}
                                        />
                                    </div>
                                </div>
                                : ""}
                        </>
                    )}

                    {mode == "Scan" && show==1?
                    <p style={{marginTop: "10px"}}>Based on your card, we have pulled the following information shown above. Please verify and enter correct information before final submission</p>:""
                    }
                  {mode == "Scan" ?(  
                    <div>
                        {outputImages.front === null ? (
                                <div className="resultbox1 mt-4 mb-2" style={{ "--background-image": `url(${front})` }}>
                                    {loaders.front &&
                                        <div className="overlay-text" style={overlayTextBoxStyle}>
                                            <div style={{ textAlign: "center", position: "absolute", display: "flex",width: "100%",justifyContent:"center" }}>
                                                <img className="loader-img" style={{ width: "30%" }} src={loading} alt="Loading..." />
                                            </div>
                                        </div>
                                    }
                                    {!files.front && 
                                        <div className="overlay-text" onClick={() => fileInputRefs.front.current.click()}>
                                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 48 48">
                                                <path fill="#FFFFFF" d="M 23.978516 6 A 1.50015 1.50015 0 0 0 22.939453 6.4394531 L 16.939453 12.439453 A 1.50015 1.50015 0 1 0 19.060547 14.560547 L 22.5 11.121094 L 22.5 32.5 A 1.50015 1.50015 0 1 0 25.5 32.5 L 25.5 11.121094 L 28.939453 14.560547 A 1.50015 1.50015 0 1 0 31.060547 12.439453 L 25.060547 6.4394531 A 1.50015 1.50015 0 0 0 23.978516 6 z M 11.5 17 C 8.4802259 17 6 19.480226 6 22.5 L 6 36.5 C 6 39.519774 8.4802259 42 11.5 42 L 36.5 42 C 39.519774 42 42 39.519774 42 36.5 L 42 22.5 C 42 19.480226 39.519774 17 36.5 17 L 34.5 17 A 1.50015 1.50015 0 1 0 34.5 20 L 36.5 20 C 37.898226 20 39 21.101774 39 22.5 L 39 36.5 C 39 37.898226 37.898226 39 36.5 39 L 11.5 39 C 10.101774 39 9 37.898226 9 36.5 L 9 22.5 C 9 21.101774 10.101774 20 11.5 20 L 13.5 20 A 1.50015 1.50015 0 1 0 13.5 17 L 11.5 17 z"></path>
                                            </svg>
                                            <div>Upload or Scan Front Of card</div>
                                        </div>
                                    }
                                </div>
                            ):(
                                show !=1?
                                    <div className="mt-4 mb-2" style={{ justifyContent: "center" }}>
                                        <div className="resultbox">
                                            <img style={{ width: "100%", height: "213px", objectFit: "contain" }} src={`data:image/jpeg;base64,${outputImages.front}`} alt="img" />
                                        </div>
                                    </div>:""
                            )}

                            {outputImages.back === null ? (
                                <div className="resultbox1 mb-4 mt-4" style={{ "--background-image": `url(${back})` }}>
                                {loaders.back &&
                                    <div className="overlay-text" style={overlayTextBoxStyle}>
                                        <div style={{ textAlign: "center", position: "absolute", display: "flex",width: "100%",justifyContent:"center" }}>
                                            <img className="loader-img" style={{ width: "30%" }} src={loading} alt="Loading..." />
                                        </div>
                                    </div>
                                }
                                {!files.back &&
                                    <div className="overlay-text" onClick={() => fileInputRefs.back.current.click()}>
                                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="50" height="50" viewBox="0 0 48 48">
                                            <path fill="#FFFFFF" d="M 23.978516 6 A 1.50015 1.50015 0 0 0 22.939453 6.4394531 L 16.939453 12.439453 A 1.50015 1.50015 0 1 0 19.060547 14.560547 L 22.5 11.121094 L 22.5 32.5 A 1.50015 1.50015 0 1 0 25.5 32.5 L 25.5 11.121094 L 28.939453 14.560547 A 1.50015 1.50015 0 1 0 31.060547 12.439453 L 25.060547 6.4394531 A 1.50015 1.50015 0 0 0 23.978516 6 z M 11.5 17 C 8.4802259 17 6 19.480226 6 22.5 L 6 36.5 C 6 39.519774 8.4802259 42 11.5 42 L 36.5 42 C 39.519774 42 42 39.519774 42 36.5 L 42 22.5 C 42 19.480226 39.519774 17 36.5 17 L 34.5 17 A 1.50015 1.50015 0 1 0 34.5 20 L 36.5 20 C 37.898226 20 39 21.101774 39 22.5 L 39 36.5 C 39 37.898226 37.898226 39 36.5 39 L 11.5 39 C 10.101774 39 9 37.898226 9 36.5 L 9 22.5 C 9 21.101774 10.101774 20 11.5 20 L 13.5 20 A 1.50015 1.50015 0 1 0 13.5 17 L 11.5 17 z"></path>
                                        </svg>
                                        <div>Scan Or Upload Back of Card</div>
                                    </div>
                                }
                                </div>
                        ) : ( 
                            show != 1?
                            <div className=" mb-4 mt-4" style={{ justifyContent: "center" }}>
                                <div className="resultbox">
                                    <img style={{ width: "100%", height: "213px", objectFit: "contain" }} src={`data:image/jpeg;base64,${outputImages.back}`} alt="img" />
                                </div>
                            </div>:""
                        )}
                    {show == 1?    
                        (
                            <div className="cc-wrap"
                                style={{
                                    display: "flex",
                                    overflowX: "auto",
                                    gap: "0px",
                                    // marginTop: "40px",
                                    padding: "0px",
                                    background: "#FFFFFF",
                                    border: "1px solid #ddd",
                                    height: "200px"
                                }}
                            >
                                {outputImages.front && 
                                <div className="cc-single"
                                // key={index}
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexShrink: 0,
                                    width: "50%",
                                    padding: "5px",
                                    background: "#FFFFFF",
                                    borderRight: "1px solid #ddd",
                                    cursor: "pointer"
                                }}
                            >
                                <img
                                    style={{
                                        width: "100%",
                                        objectFit: "contain",
                                        // border: "2px solid #d0caca",
                                    }}
                                    src={`data:image/jpeg;base64,${outputImages.front}`}
                                    alt="img"
                                    // onClick={() => handleimagepreview(index)}
                                />
                            </div>
                            }
                                {outputImages.back && 
                                <div className="cc-single"
                                // key={index}
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    flexShrink: 0,
                                    width: "50%",
                                    padding: "5px",
                                    background: "#FFFFFF",
                                    borderRight: "1px solid #ddd",
                                    cursor: "pointer"
                                }}
                            >
                                <img
                                    style={{
                                        width: "100%",
                                        objectFit: "contain",
                                        // border: "2px solid #d0caca",
                                    }}
                                    src={`data:image/jpeg;base64,${outputImages.back}`}
                                    alt="img"
                                    // onClick={() => handleimagepreview(index)}
                                />
                            </div>
                            }
                            </div>
                        ):""}
                    </div>):(
                        <div className="mt-4 mb-2">
                            <Creditcardform
                                setSubmitFunction={(submitFunction) => (childSubmitFunction = submitFunction)}
                                cardnumber=''
                                cardholder=''
                                card_type=''
                                ExpiryDate=''
                                cvv_number=''
                                zipcode=''
                                uuid= {props.uuid}
                            />
                        </div>
                        
                    )}

                {mode == "Manual" ? <p>Please verify and enter correct information before final submission.</p>:""}

                </div>

                </div>
                <input type="file" ref={fileInputRefs.front} style={{ display: 'none' }} onChange={() => fileHandle("front")} />
                <input type="file" ref={fileInputRefs.back} style={{ display: 'none' }} onChange={() => fileHandle("back")} />
            <div className="copyright pb-2 mt-2" style={{fontWeight:"500",fontSize:"15px",width:"100%"}}>
            
            
            {(show !== 0 || mode !="Scan" ) ?
                    <div className="submitbtn">
                        <button onClick={handleSubmitinfo} className="btn btn-xl w-100 btn-primary saveinfo">Submit</button>
                    </div>
                    : ""}
            </div>

            {outputImages.front && outputImages.back && show != 1 && mode != "Manual" ?
                    <div className="submitbtn">
                        <button onClick={proceed} className="btn btn-xl w-100 btn-primary">Next</button>
                    </div>
                : ""}
        </div>
        </div>
        </div>
        
        <Footer/>
        </>
    );
};

export default Creditcard;
